import { SegmentSchema } from '@sondermind/segment';

export interface IClinicalQuestionnaireClickedDoneData {
  buttonText: string;
  cqType: string;
  isPaginated: boolean;
  questionnaireId: string;
}

export interface IClinicalQuestionnaireClickedNextData {
  cqType: string;
  providerId?: string;
  questionnaireId: string;
}

export interface IMatchflowSubmittedData {
  flow: string;
}

export interface IMatchFlowStepSubmitted {
  flow: string;
  step_name: string;
  answer: Record<string, string | number>;
}

export interface IMatchflowStartedData {
  flow: string;
  referralSource: string;
  referringUrl: string;
}

interface IProviderFinishesAssessmentData {
  cqType: string;
  dateAdministered?: Date;
  location: 'video' | 'provider_portal';
  providerId: string;
  clientId: string;
}

export enum FlowsHostSegmentEvents {
  // Assessment/CQ events
  CQ_CLICKED_DONE = 'Client clicked DONE button after completing CQ',
  CQ_CLICKED_NEXT = 'User clicked NEXT button after completing CQ',
  PROVIDER_FINISHES_ASSESSMENT = 'Provider finishes assessment',

  // Match Flow events
  MATCH_FLOW_SUBMITTED = 'Client Match Flow Submit Button Clicked',
  MATCH_FLOW_STEP_SUBMITTED = 'Client Match Flow Step Submitted',
  MATCH_FLOW_STARTED = 'Client Match Flow Started',
  MATCH_FLOW_REDIRECTED_TO_AUTH0 = 'Client Match Flow Redirect to Auth0',
}

export interface IFlowsHostSegmentSchema extends SegmentSchema {
  [FlowsHostSegmentEvents.CQ_CLICKED_DONE]: IClinicalQuestionnaireClickedDoneData;
  [FlowsHostSegmentEvents.CQ_CLICKED_NEXT]: IClinicalQuestionnaireClickedNextData;
  [FlowsHostSegmentEvents.PROVIDER_FINISHES_ASSESSMENT]: IProviderFinishesAssessmentData;
  [FlowsHostSegmentEvents.MATCH_FLOW_SUBMITTED]: IMatchflowSubmittedData;
  [FlowsHostSegmentEvents.MATCH_FLOW_STEP_SUBMITTED]: IMatchFlowStepSubmitted;
  [FlowsHostSegmentEvents.MATCH_FLOW_STARTED]: IMatchflowStartedData;
}
